import axios from "axios";
import isString from "lodash/isString";
const FILES_STORAGE_URL = process.env.REACT_FILES_STORAGE_URL;
export default {
    saveFile: (data) => {
        const formData = new FormData();
        formData.append("file", data.file, data.fullName);
        return axios
            .post("/Documents/saveFile", formData, {
            params: { onlyName: true }
        })
            .then(response => {
            response.data = `${FILES_STORAGE_URL}/${response.data}`;
            return response;
        });
    },
    voiceRecognition: (data) => {
        const formData = new FormData();
        formData.append("file", data.file, data.fullName);
        return axios.post("/Neiro/Voice", formData).then(response => {
            response.data = isString(response.data) ? String(response.data) : undefined;
            return response;
        });
    }
};
